import { mapState, mapActions } from 'pinia';
import { usePageStore } from '@/store';
export default {
    computed: {
        ...mapState(usePageStore, {
            page: store => (store.page || {}),
            currentCurrency: store => store.currency.abbr,
            currentCurrencyLabel: store => {
                let { abbr, symbol } = store.currency;
                return `${abbr}(${symbol})`;
            },
            showCurrency: store => store.showCurrency,
            currencyList: store => store.currencyList,
        }),
        curencyMenu({ currencyList }) {
            return {
                items: currencyList
            };
        }
    },
    methods: {
        ...mapActions(usePageStore, {
            selectCurrency: 'selectCurrency'
        })
    }
};
